import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function TicketNew() {
    const navigate = useNavigate();
    const [clients, setClients] = useState([]);
    const [cats, setCats] = useState([]);
    const [clientId, setClientId] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        api.get("/internal/clients", { params: { status: "active", page_size: 200 } }).then(({ data }) => setClients(data.items || []));
        api.get("/internal/ticket-categories", { params: { active: "true" } }).then(({ data }) => setCats(data.items || []));
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            const { data } = await api.post("/internal/tickets", {
                client_id: clientId, title: title.trim(), category_id: categoryId, message: message.trim(),
            });
            toast.success("Ticket aperto");
            navigate(`/app/ticket/${data.id}`, { replace: true });
        } catch (err) {
            setError(err?.response?.data?.detail || "Errore");
        } finally { setLoading(false); }
    };

    return (
        <div style={{ padding: "32px 40px", maxWidth: 740 }} data-testid="ticket-new-page">
            <Link to="/app/ticket" className="lt-link" style={{ display: "inline-flex", alignItems: "center", gap: 6, marginBottom: 20 }}>
                <ArrowLeft size={14} /> Torna ai ticket
            </Link>
            <h1 className="lt-h1" style={{ marginBottom: 8 }}>Nuovo ticket</h1>
            <p className="lt-sub" style={{ marginBottom: 24 }}>Apri un ticket interno per conto di un cliente.</p>

            <form onSubmit={submit} className="lt-card" style={{ padding: 32 }} data-testid="ticket-new-form">
                <label className="lt-label">Cliente</label>
                <select className="lt-field" value={clientId} onChange={(e) => setClientId(e.target.value)} required data-testid="ticket-new-client">
                    <option value="" disabled>Seleziona un cliente…</option>
                    {clients.map((c) => <option key={c.id} value={c.id}>{c.company_name}</option>)}
                </select>
                <label className="lt-label">Titolo</label>
                <input className="lt-field" value={title} onChange={(e) => setTitle(e.target.value)} required minLength={3} maxLength={160} data-testid="ticket-new-title" />
                <label className="lt-label">Categoria</label>
                <select className="lt-field" value={categoryId} onChange={(e) => setCategoryId(e.target.value)} required data-testid="ticket-new-category">
                    <option value="" disabled>Seleziona una categoria…</option>
                    {cats.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
                <label className="lt-label">Messaggio</label>
                <textarea className="lt-field" value={message} onChange={(e) => setMessage(e.target.value)} required rows={5} data-testid="ticket-new-message" />
                {error && <div style={{ fontSize: 13, color: "#B23A48", marginBottom: 12 }}>{error}</div>}
                <div className="flex items-center justify-end gap-3">
                    <Link to="/app/ticket" className="lt-btn-secondary">Annulla</Link>
                    <button className="lt-btn-primary" type="submit" disabled={loading} data-testid="ticket-new-submit">{loading ? "Apertura…" : "Apri ticket"}</button>
                </div>
            </form>
        </div>
    );
}
